<template>
  <v-expansion-panel>
    <v-expansion-panel-header ripple>
      <v-row>
        <v-col cols="12">
          <v-flex class="d-flex flex-column text-break">
            <span
              class="caption grey--text text--darken-1"
            >
              Análise {{fieldPostProcessing["ab_crop_type"] | cropTypeDisplay}} - {{fieldPostProcessing["dh_created"] | dateDisplay}}
            </span>
            <span
              class="caption font-weight-light grey--text"
              v-text="fieldPostProcessing['cd_unique_identifier']"
            />
          </v-flex>
        </v-col>
      </v-row>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <v-container
        fluid
        class="pa-1 px-0"
      >
        <v-row
          class="ma-0"
        >
          <post-processing-result-analysis-card
            v-for="ppa in fieldPostProcessing['post_processings_analysis']"
            :key="ppa['id_post_processing_analysis']"
            :post-processing-analysis="ppa"
          />
        </v-row>
      </v-container>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
  import PostProcessingResultAnalysisCard from "./PostProcessingResultAnalysisCard"
  import {CROP_TYPES_NAMES} from "../../../../helpers/fields/constants"
  import moment from "moment"

  export default {
    name: "PostProcessingResultSubPanel",
    components: {PostProcessingResultAnalysisCard},
    props: {
      fieldPostProcessing: {
        type: Object,
        required: true
      }
    },
    methods: {},
    filters: {
      cropTypeDisplay(cropType) {
        if (!cropType) return ""

        const displayName = CROP_TYPES_NAMES[cropType]
        if (!displayName) return "Cultura desconhecida"
        return displayName
      },
      dateDisplay(value) {
        return moment(value).format("DD/MM/YYYY")
      },
    },
    created() {
    }
  }
</script>

<style scoped lang="scss">
  ::v-deep .v-expansion-panel-content__wrap {
    padding: 0 12px 12px;
  }
</style>
